//NPM Packages
import { React, useContext, useEffect, useState } from "react";
import axios from "axios";
import styled from "styled-components";

//Context
import MyContext from "../../context/MyContext";

//Data
import { CountryData } from "../../data/CountryData";

//Styled Components
import { Col } from "../styles/Col";
import { Dropdown } from "../styles/Dropdown.styled";
import { Form } from "../styles/Form.styled";
import { Input } from "../styles/Input.styled";
import { Row } from "../styles/Row";
import Loader from "../styles/Loader.styled";
import LamininError from "../Shared/LamininError";

const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${(props) => props.theme.space[1]};
  margin: ${(props) => props.theme.space[0]};
  margin-top: 1rem;
`;

const FormHeading = styled.div`
  padding: ${(props) => props.theme.space[1]};
  margin: ${(props) => props.theme.space[0]};
  font-size: x-large;
`;

const FormSubHeading = styled.div`
  padding: ${(props) => props.theme.space[1]};
  margin: ${(props) => props.theme.space[0]};
  font-size: large;
`;

const FormBody = styled.div`
  padding: ${(props) => props.theme.space[1]};
  margin: ${(props) => props.theme.space[0]};
  font-size: large;
`;

const FormLabel = styled.label`
  padding: ${(props) => props.theme.space[1]};
  font-size: medium;
`;

const FormWrapper = styled.div``;

const Label = styled.label`
  padding-left: ${(props) => props.theme.space[1]};
  padding-top: ${(props) => props.theme.space[1]};
  font-size: medium;
  color: ${({ theme }) => theme.colors.primary};
`;

const ItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: left;
  justify-content: left;
  padding: ${(props) => props.theme.space[1]};
  margin: ${(props) => props.theme.space[0]};
  border: 1px solid #bbb;
  border-radius: 3px;
  width: 100%;
`;

const ValidationMessage = styled.div`
  padding: ${(props) => props.theme.space[1]};
  margin: ${(props) => props.theme.space[0]};
  font-size: small;
  color: red;
`;

const ValidationSubHeading = styled.div`
  padding: ${(props) => props.theme.space[1]};
  margin: ${(props) => props.theme.space[0]};
  font-size: large;
  color: red;
`;

export default function Customer(props) {
  const {
    dev,
    data,
    setData,
    dataUpdated,
    setDataUpdated,
    headers,

    //Errors
    ageError,
    setAgeError,
    formError,
    setFormError,
    homeNumberError,
    setHomeNumberError,
    idNumberError,
    setIdNumberError,
    mobileError,
    setMobileError,
    workNumberError,
    setWorkNumberError,
    setCustomerDataCaptured,
  } = useContext(MyContext);

  const [lamininSubmitted, setLamininSubmitted] = useState(false);
  const [lamininError, setLamininError] = useState(false);

  const currentDate = new Date().toISOString().split("T")[0];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const calculateAge = (birthDate, otherDate) => {
    birthDate = new Date(birthDate);
    otherDate = new Date(otherDate);
    var years = otherDate.getFullYear() - birthDate.getFullYear();
    if (
      otherDate.getMonth() < birthDate.getMonth() ||
      (otherDate.getMonth() === birthDate.getMonth() &&
        otherDate.getDate() < birthDate.getDate())
    ) {
      years--;
    }
    return years;
  };

  const getCurrentDate = () => {
    const dateObject = new Date();
    const date = dateObject.toISOString().split("T")[0];
    setData((prevValue) => {
      return {
        ...prevValue,
        signedDate: date,
      };
    });
  };

  const isValidDate = (date) => {
    const timestamp = Date.parse(date);
    return !isNaN(timestamp);
  };

  const saveLeadId = (leadId) => {
    setData((prevValue) => {
      return {
        ...prevValue,
        leadId: leadId,
      };
    });
  };

  const createLead = () => {
    setLamininSubmitted(true);
    axios
      .post(dev ? "http://localhost:5000/api/create" : "api/create", data, {
        headers: headers,
      })
      .then(
        (response) => {
          if (response.status === 200) {
            console.log("Laminin Response OK: " + response.status);
            const { NewLeadId } = response.data;
            saveLeadId(NewLeadId);
            setCustomerDataCaptured(true);
          } else {
            console.log("Laminin Response Not OK: " + response.status);
            setLamininError(true);
          }
        },
        (error) => {
          console.log("Laminin Response Error: " + error);
          setLamininError(true);
        }
      );
  };

  const updateLead = () => {
    setDataUpdated(false);
    setLamininSubmitted(true);
    axios
      .post(dev ? "http://localhost:5000/api/update" : "api/update", data, {
        headers: headers,
      })
      .then(
        (response) => {
          if (response.status === 200) {
            console.log("Laminin Response OK: " + response.status);
            setCustomerDataCaptured(true);
          } else {
            console.log("Laminin Response Not OK: " + response.status);
            setLamininError(true);
          }
        },
        (error) => {
          console.log("Laminin Response Error: " + error);
          setLamininError(true);
        }
      );
  };

  const handleInfoChange = (event) => {
    const { name, value } = event.target;
    setDataUpdated(true);
    setData((prevValue) => {
      return {
        ...prevValue,
        [name]: value,
      };
    });

    // Create DOB from ID Number
    if (
      name === "idType" &&
      value === "ID Document" &&
      data.idNumber.length === 13 &&
      !data.dob
    ) {
      const century = currentDate.toString().substring(0, 2);
      const year = currentDate.toString().substring(2, 4);
      const idYear = data.idNumber.substring(0, 2);
      let dateString = "";

      if (idYear >= 0 && idYear <= year) {
        dateString = `${century}${data.idNumber.substring(
          0,
          2
        )}-${data.idNumber.substring(2, 4)}-${data.idNumber.substring(4, 6)}`;
      } else {
        dateString = `${century - 1}${data.idNumber.substring(
          0,
          2
        )}-${data.idNumber.substring(2, 4)}-${data.idNumber.substring(4, 6)}`;
      }

      if (isValidDate(dateString)) {
        const calculatedDOB = new Date(dateString).toISOString().split("T")[0];
        setData((prevValue) => {
          return {
            ...prevValue,
            dob: calculatedDOB,
          };
        });
      }
    }
  };

  const handleFormSubmit = (event) => {
    event.preventDefault();
    let isValid = true;

    // ID number validation
    if (data.idNumber.length !== 13 || isNaN(data.idNumber)) {
      setIdNumberError(
        "Please enter a valid 13-digit ID number without any spaces"
      );
      isValid = false;
    } else {
      setIdNumberError("");
      setFormError("");
    }

    // Mobile number validation
    if (data.mobile.length !== 10 || isNaN(data.mobile)) {
      setMobileError(
        "Please enter a valid 10-digit phone number without any spaces, example 0812345678"
      );
      isValid = false;
    } else {
      setMobileError("");
      setFormError("");
    }

    // Work number validation
    if (data.workTelNo) {
      if (data.workTelNo.length !== 10 || isNaN(data.workTelNo)) {
        setWorkNumberError(
          "Please enter a valid 10-digit phone number without any spaces, example 0812345678"
        );
        isValid = false;
      } else {
        setWorkNumberError("");
        setFormError("");
      }
    }

    // Home number validation
    if (data.homeTelNo) {
      if (data.homeTelNo.length !== 10 || isNaN(data.homeTelNo)) {
        setHomeNumberError(
          "Please enter a valid 10-digit phone number without any spaces, example 0812345678"
        );
        isValid = false;
      } else {
        setHomeNumberError("");
        setFormError("");
      }
    }

    // Check Age
    const calculatedAge = calculateAge(data.dob, currentDate);
    if (calculatedAge < 18) {
      setAgeError(
        "The applicant is less than 18 years old and does not qualify for a credit card"
      );
      isValid = false;
    } else {
      setAgeError("");
      setFormError("");
    }

    if (!isValid) {
      setFormError(
        "Note: There are errors on this form. Please correct and click on Next to continue."
      );
      window.scrollTo(0, 0);
    }

    if (isValid) {
      
       getCurrentDate();
      if (data.leadId === "") {
        createLead();
      } else {
        if (dataUpdated) {
          updateLead();
        } else {
          setCustomerDataCaptured(true);
        }
      }
    }
  };

  return (
    <Form onSubmit={handleFormSubmit}>
      <FormHeading>
        {props.name} - {props.formName}
      </FormHeading>
      {!lamininSubmitted && (
        <FormWrapper>
      <FormSubHeading>Note: Please complete each page in full</FormSubHeading>
      {formError && <ValidationSubHeading>{formError}</ValidationSubHeading>}
      <FormBody>
        <ItemWrapper>
          <FormLabel>Customer Information</FormLabel>
          <Row>
            <Col $md={6} style={{ padding: "0 1% 0 0" }}>
              <Label>Title (Required)</Label>
              <Dropdown
                name="title"
                onChange={handleInfoChange}
                required={true}
                value={data.title}
                width="100%"
              >
                <option value="" disabled hidden>
                  Please select
                </option>
                <option value="Mr">Mr</option>
                <option value="Mrs">Mrs</option>
                <option value="Ms">Ms</option>
                <option value="Dr">Dr</option>
                <option value="Prof">Prof</option>
              </Dropdown>
            </Col>
            <Col $md={6} style={{ padding: "0 1% 0 0" }}>
              <Label>Initials (Required)</Label>
              <Input
                type="text"
                name="initials"
                onChange={handleInfoChange}
                placeholder=""
                required={true}
                value={data.initials}
                width="100%"
              />
            </Col>
          </Row>
          <Row>
            <Col $md={6} style={{ padding: "0 1% 0 0" }}>
              <Label>First Name (Required)</Label>
              <Input
                type="text"
                name="firstName"
                onChange={handleInfoChange}
                placeholder=""
                required={true}
                value={data.firstName}
                width="100%"
              />
            </Col>
            <Col $md={6} style={{ padding: "0 1% 0 0" }}>
              <Label>Surname (Required)</Label>
              <Input
                type="text"
                name="lastName"
                onChange={handleInfoChange}
                placeholder=""
                required={true}
                value={data.lastName}
                width="100%"
              />
            </Col>
          </Row>
          <Row>
            <Col $md={6} style={{ padding: "0 1% 0 0" }}>
              <Label>Gender (Required)</Label>
              <Dropdown
                name="gender"
                onChange={handleInfoChange}
                required={true}
                value={data.gender}
                width="100%"
              >
                <option value="" disabled hidden>
                  Please select
                </option>
                <option value="Female">Female</option>
                <option value="Male">Male</option>
              </Dropdown>
            </Col>
            <Col $md={6} style={{ padding: "0 1% 0 0" }}>
              <Label>ID Number (Required)</Label>
              <Input
                type="text"
                name="idNumber"
                onChange={handleInfoChange}
                placeholder=""
                required={true}
                value={data.idNumber}
                width="100%"
                maxLength={13}
              />
              {idNumberError && (
                <ValidationMessage>{idNumberError}</ValidationMessage>
              )}
            </Col>
          </Row>
          <Row>
            <Col $md={6} style={{ padding: "0 1% 0 0" }}>
              <Label>Identity Type (Required)</Label>
              <Dropdown
                name="idType"
                onChange={handleInfoChange}
                required={true}
                value={data.idType}
                width="100%"
              >
                <option value="" disabled hidden>
                  Please select
                </option>
                <option value="ID Document">ID Document</option>
                <option value="Passport">Passport</option>
              </Dropdown>
            </Col>
            <Col $md={6} style={{ padding: "0 1% 0 0" }}>
              <Label>Issuing Country (Required)</Label>
              <Dropdown
                name="idCountry"
                onChange={handleInfoChange}
                required={true}
                value={data.idCountry}
                width="100%"
              >
                <option value="" disabled hidden>
                  Please select
                </option>
                {CountryData.map((country, index) => {
                  return (
                    <option value={country.code} key={index}>
                      {country.name}
                    </option>
                  );
                })}
              </Dropdown>
            </Col>
          </Row>
          <Row>
            <Col $md={6} style={{ padding: "0 1% 0 0" }}>
              <Label>Date of Birth (Required)</Label>
              <Input
                type="text"
                name="dob"
                onChange={handleInfoChange}
                placeholder=""
                onFocus={(e) => (e.target.type = "date")}
                onBlur={(e) => (e.target.type = "text")}
                required={true}
                value={data.dob}
                width="100%"
                max="9999-12-31"
              />
            </Col>
            {ageError && <ValidationMessage>{ageError}</ValidationMessage>}
            <Col $md={6} style={{ padding: "0 1% 0 0" }}>
              <Label>Marital Status (Required)</Label>
              <Dropdown
                name="maritalStatus"
                onChange={handleInfoChange}
                required={true}
                value={data.maritalStatus}
                width="100%"
              >
                <option value="" disabled hidden>
                  Please select
                </option>
                <option value="Single">Single</option>
                <option value="Married">Married</option>
                <option value="Seprated">Seprated</option>
                <option value="Divorced">Divorced</option>
                <option value="Widowed">Widowed</option>
                <option value="Unclassified">Unclassified</option>
              </Dropdown>
            </Col>
          </Row>
        </ItemWrapper>
        <ItemWrapper>
          <FormLabel>Contact Information</FormLabel>
          <Row>
            <Col $md={6} style={{ padding: "0 1% 0 0" }}>
              <Label>Mobile Telephone Number (Required)</Label>
              <Input
                type="text"
                name="mobile"
                onChange={handleInfoChange}
                placeholder=""
                required={true}
                value={data.mobile}
                width="100%"
                maxLength={10}
              />
              {mobileError && (
                <ValidationMessage>{mobileError}</ValidationMessage>
              )}
            </Col>
            <Col $md={6} style={{ padding: "0 1% 0 0" }}>
              <Label>Business Telephone Number</Label>
              <Input
                type="text"
                name="workTelNo"
                onChange={handleInfoChange}
                placeholder=""
                required={false}
                value={data.workTelNo}
                width="100%"
                maxLength={10}
              />
              {workNumberError && (
                <ValidationMessage>{workNumberError}</ValidationMessage>
              )}
            </Col>
          </Row>
          <Row>
            <Col $md={6} style={{ padding: "0 1% 0 0" }}>
              <Label>Home Telephone Number</Label>
              <Input
                type="text"
                name="homeTelNo"
                onChange={handleInfoChange}
                placeholder=""
                required={false}
                value={data.homeTelNo}
                width="100%"
                maxLength={10}
              />
              {homeNumberError && (
                <ValidationMessage>{homeNumberError}</ValidationMessage>
              )}
            </Col>
            <Col $md={6} style={{ padding: "0 1% 0 0" }}>
              <Label>Email (Required)</Label>
              <Input
                type="email"
                name="email"
                onChange={handleInfoChange}
                placeholder=""
                required={true}
                value={data.email}
                width="100%"
              />
            </Col>
          </Row>
          <Row>
            <Col $md={6} style={{ padding: "0 1% 0 0" }}>
              <Label>Preferred Communication Type (Required)</Label>
              <Dropdown
                name="preferredCommunicationType"
                onChange={handleInfoChange}
                required={true}
                value={data.preferredCommunicationType}
                width="100%"
              >
                <option value="" disabled hidden>
                  Please select
                </option>
                <option value="Email">Email</option>
                <option value="Phone">Phone</option>
                <option value="SMS">SMS</option>
                <option value="WhatsApp">WhatsApp</option>
              </Dropdown>
            </Col>
          </Row>
        </ItemWrapper>
      </FormBody>
      <ButtonWrapper>
        <button
          className="btn btn-dark btn-md"
          type="submit"
          style={{ margin: "0 2px" }}
        >
          Next
        </button>
      </ButtonWrapper>
      </FormWrapper>
      )}

      {lamininSubmitted && !lamininError && <Loader />}
      {lamininError && <LamininError phone={props.phone} />}
    </Form>
  );
}
